import { render, staticRenderFns } from "./domainStatusModal.vue?vue&type=template&id=24593c14&scoped=true&"
import script from "./domainStatusModal.vue?vue&type=script&lang=js&"
export * from "./domainStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./domainStatusModal.vue?vue&type=style&index=0&id=24593c14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24593c14",
  null
  
)

export default component.exports